// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3JYsU","fileBtn":"File_fileBtn__gVWKJ","closeBtn":"File_closeBtn__1mgEM","fileSelected":"File_fileSelected__2svEI","disabled":"File_disabled__3TCqQ"};